import React, { useEffect, useState } from "react";
import axios from "axios";
import config from "../../../../Helpers/config.json";
import { errorMessages } from "../../../../Helpers/ErrorMessages";
import { convDate } from "../../../../Utils/ConvertDate";
import { useRecordExpenses } from "./useRecordExpense";
// import dayjs from "dayjs"; // ✅ for date handling

export const useExpenses = (actions, component) => {
  const [expenses, setExpenses] = useState([]);
  const [state, setState] = useState({ startDate: "", endDate: "" });
  const [loading, setLoading] = useState("idle");
  const [submitted, setSubmitted] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState("idle");
  const [openCancel, setOpenCancel] = useState(false);
  const [canceledExpense, setCanceledExpense] = useState({});
  const [activePage, setActivePage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchValue, setSearchValue] = useState("");
  const [total_count, setTotalCount] = useState(0);
  const [page,setPage] = useState('')

  // ✅ Get today's date in YYYY-MM-DD format (native JS)
  const today = new Date().toISOString().split("T")[0];

  const [startDate, setStartDate] = useState(today);
  const [endDate, setEndDate] = useState(today);

  // const [searchValue, setSearchValue] = useState("");

  const handleChangeStartDate = (date) => setStartDate(date);
  const handleChangeEndDate = (date) => setEndDate(date);
  // const handleChangeSearch = (e) => setSearchValue(e.target.value);

  const { expenseProps } = useRecordExpenses(actions);
  const { isResolved: isExpenseResolved } = expenseProps;
  // const {startDate,endDate} = state
   const voucher_id = expenses.voucher_id

  const isCanceled = isSubmitted === "resolvedCancel";
  const [editingExpense, setEditingExpense] = useState(null);
  const [paymentAccounts, setPaymentAccounts] = useState([]);

  useEffect(() => {
    const fetchPaymentAccounts = async () => {
      try {
        const res = await axios.get(
          `${config.epharmUrl}/accounting/get_cash_and_bank_accounts`,
        );
        let _data = res.data;
        let dt = _data ?? [];
        const formatted = dt.map((i) => ({
          label:  i.head_name,
          value: i.id,
        }));
        setPaymentAccounts(formatted);
        
        // setPaymentAccounts(formatted);
      } catch (err) {
        console.error("Error fetching payment accounts:", err);
        setPaymentAccounts([]);
      }
    };
  
    fetchPaymentAccounts();
  }, [startDate, endDate, activePage, searchValue]);
  

  const refresbdata = async () => {
    try {
      // Trigger fetching expenses again
      const res = await axios.get(`${config.epharmUrl}/accounting/retrive_expenses_data`, {
        params: {
          startDate,
          endDate,
          page: activePage,
          search: searchValue,
        },
      });
  
      const _data = res.data;
      const expensesData = _data.expenses ?? [];
      const total_count = _data.total_items;
  
      const formatted = expensesData.map(
        ({ details, category, expense_date, payment, total_amount, vendor_name, voucher_id, ...rest }) => ({
          ...rest,
          details: details ?? "N/A",
          category: category ?? "N/A",
          expense_date: expense_date ?? "N/A",
          payment: payment ?? "N/A",
          total_amount: total_amount ?? "N/A",
          vendor_name: vendor_name ?? "N/A",
          voucher_id: voucher_id ?? "N/A",
        })
      );
  
      setExpenses(formatted);
      setTotalCount(total_count);
    } catch (err) {
      console.error("Failed to refresh expenses", err);
    }
  };
  
  useEffect(() => {
    (async () => {
      setLoading("pending");
      try {
        const res = await axios.get(`${config.epharmUrl}/accounting/retrive_expenses_data`, {
          params: {
            startDate:startDate,
            endDate:endDate,
            page: activePage,
            search: searchValue,
          },
        });
        let _data = res.data;
        const expenses= _data.expenses ?? []
        const total_count = _data.total_items;
        const array = expenses.map(({ details,category, expense_date, payment, total_amount, vendor_name,voucher_id,...rest }) => ({
          ...rest,
          details: details ??"N/A",
          category: category ??"N/A",
          expense_date: expense_date ??"N/A",
          payment: payment ??"N/A", 
          total_amount: total_amount ??"N/A",
          vendor_name: vendor_name ??"N/A",
          voucher_id: voucher_id ??"N/A",
        }));
        setExpenses(array);
        setTotalCount(total_count);
        setLoading("success");
      } catch (e) {
        // errorMessages(e, null, actions)
        setLoading("error");
      }
    })();
  }, [isExpenseResolved,activePage, searchValue,startDate, endDate, searchValue,]);



  // const fetchExpenses = async () => {
  //   setIsLoading(true);
  //   try {
  //     const res = await axios.get(`${config.epharmUrl}/accounting/expenses`, {
  //       params: {
  //         search: searchValue,
  //         start_date: startDate,
  //         end_date: endDate,
  //         page: activePage,
  //       },
  //     });
  //     setExpenses(res.data || []);
  //     setTotalCount(res.data?.length || 0);
  //     setIsSuccess(true);
  //   } catch (err) {
  //     console.error("Failed to fetch expenses", err);
  //     setExpenses([]);
  //     setIsSuccess(false);
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };
  
  
  const handleChange = (e) => {
    const { name, value } = e.target;
    setState({ ...state, [name]: value });
  };

  const handleOpenCancel = (obj) => {
    setOpenCancel(true);
    setCanceledExpense(obj);
  };

  const handleCloseCancel = () => {
    setOpenCancel(false);
  };

  const handleDeleteExpense = async (expense) => {
    const confirmDelete = window.confirm(
      `Are you sure you want to delete expense: ${expense?.vendor_name}?`
    );
    if (!confirmDelete) return;
  
    try {
      // ✅ Only call if the method exists (fixes ESLint)
      if (actions?.snackbarActions?.infoSnackbar) {
        actions.snackbarActions.infoSnackbar("Deleting expense...");
      }
      console.warn("expense === ",expense)
  
      const response = await axios.delete(
        `${config.epharmUrl}/accounting/delete_expense/${expense?.id}`
      );
  
      const result = response.data;
  
      if (response.status === 200 && result.status === 200) {
        if (actions?.snackbarActions?.successSnackbar) {
          actions.snackbarActions.successSnackbar("Expense deleted successfully");
        }
  
        // ✅ Option A: refresh list from backend
        const res = await axios.get(`${config.epharmUrl}/accounting/retrive_expenses_data`, {
          params: {
            startDate: startDate,
            endDate: endDate,
            page: activePage,
            search: searchValue,
          },
        });
  
        const _data = res.data;
        const expensesData = _data.expenses ?? [];
        const total_count = _data.total_items;
  
        const formatted = expensesData.map(
          ({ details, category, expense_date, payment, total_amount, vendor_name, voucher_id, ...rest }) => ({
            ...rest,
            details: details ?? "N/A",
            category: category ?? "N/A",
            expense_date: expense_date ?? "N/A",
            payment: payment?.head_name ?? "N/A",
            total_amount: total_amount ?? "N/A",
            vendor_name: vendor_name ?? "N/A",
            voucher_id: voucher_id ?? "N/A",
          })
        );
  
        setExpenses(formatted);
        setTotalCount(total_count);
        setLoading("success");
      } else {
        throw new Error(result.message || "Failed to delete expense");
      }
    } catch (error) {
      console.error("Error deleting expense:", error);
      if (actions?.snackbarActions?.errorSnackbar) {
        actions.snackbarActions.errorSnackbar("Failed to delete expense. Please try again.");
      }
      setLoading("error");
    }
  };
    


  const handleCancelExpense = () => {
    const {
      related_expense_type,
      credit_ledger,
      debit_ledger,
      receipt_no,
      amount,
      entity_behavior_id,
      expense_id,
    } = canceledExpense;
    const dataArr = [
      {
        related_expense_type,
        receipt_no,
        amount,
        debit_ledger,
        credit_ledger,
        entity_behaviour_id: entity_behavior_id,
        expense_id,
      },
    ];
    setIsSubmitted("pendingCancel");
    axios
      .post(`${config.epharmUrl}/accounting/expenses/cancel`, dataArr)
      .then(() => {
        actions.snackbarActions.successSnackbar(
          "Expense canceled successfully"
        );
        setSubmitted(false);
        setOpenCancel(false);
        setIsSubmitted("resolvedCancel");
      })
      .catch((err) => {
        errorMessages(err, null, actions);
        setIsSubmitted("rejectedCancel");
      });
  };

  // const handleChangeActivePage = (new_page) =>{
  //     setActivePage(new_page + 1)
  // }

  const handleChangeSearch = (event) => {
    setSearchValue(event.target.value);
  };

  

  const handleChangePage = (pageNumber) => {
    setActivePage(pageNumber)
   
};

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const { startDate, endDate } = state;
    const formData = new FormData();
    formData.append("startDate", startDate);
    formData.append("endDate", endDate);
    setSubmitted(true);
    if (startDate && endDate) {
      setIsSubmitted("pending");
      axios
        .post(`${config.epharmUrl}/accounting/expenses`, formData)
        .then((res) => {
          let _data = res.data;
          let dt = _data.data ?? [];
          const arr = dt.map(
            ({
              date,
              receipt_no,
              expense_type_name,
              amount,
              expense_id,
              debit_ledger_name,
              credit_ledger_name,
              ...rest
            }) => ({
              ...rest,
              date: convDate(date),
              debit_ledger_name,
              credit_ledger_name,
              receipt_no,
              expense_type_name,
              amount,
              expense_id,
            })
          );
          setExpenses(arr);
          setIsSubmitted("resolved");
        })
        .catch((err) => {
          errorMessages(err, null, actions);
          setIsSubmitted("rejected");
        });
    }
  };

  const closeSnackbar = () => {
    actions.snackbarActions.hideSnackBar();
  };

  const isPending = isSubmitted === "pending";
  const isResolved = isSubmitted === "resolved";
  const isRejected = isSubmitted === "rejected";

  const isLoading = loading === "pending";
  const isSuccess = loading === "success";
  const isError = loading === "error";

  return {
    expenses,
    state,
    submitted,
    isPending,
    isResolved,
    isRejected,
    isLoading,
    isSuccess,
    isError,
    handleSubmit,
    handleChange,
    closeSnackbar,
    expenseProps,
    openCancel,
    canceledExpense,
    handleCancelExpense,
    handleOpenCancel,
    handleCloseCancel,
    activePage,
    page,
    rowsPerPage,
    searchValue,
    handleDeleteExpense,
    handleChangeSearch,
    handleChangeRowsPerPage,
    handleChangePage,
    startDate,            // ✅ add in your hook later
    endDate,              // ✅ add in your hook later
    handleChangeStartDate, // ✅ new handler
    handleChangeEndDate,   // ✅ new handler
    total_count,
    paymentAccounts,
    refresbdata,
    // handleEditExpense,
    // handleSubmitEditExpense,
  };
};
